import { render, staticRenderFns } from "./RichTextGallery.vue?vue&type=template&id=56c85016&scoped=true"
import script from "./RichTextGallery.vue?vue&type=script&lang=js"
export * from "./RichTextGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c85016",
  null
  
)

export default component.exports